import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'; // Assuming you use React Router for navigation
import LegalLayout from '../components/LegalLayout';

const Confidentiality = () => {
  const { t } = useTranslation();

  const sections = t('confidentiality.sections', { returnObjects: true }) || [];

  return (
    <LegalLayout 
      title={t('confidentiality.title')}
      lastUpdated={t('confidentiality.lastUpdated')}
    >
      <div className="space-y-8">
        <p className="text-lg text-gray-600">
          {t('confidentiality.intro')}
        </p>
        
        {sections.map((section, index) => (
          <section key={index}>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            <div className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
              {Array.isArray(section.content) ? (
                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-600">{section.content}</p>
              )}
            </div>
          </section>
        ))}
        
        <p className="italic text-gray-600 mt-8">
          {t('confidentiality.contact').split(/(\s+<a[^>]*>.*<\/a>)/)[0]}
          <Link to="/contact" className="text-primary hover:text-primary/80 underline">
            {t('nav.contact')} 
          </Link>.
        </p>
      </div>
    </LegalLayout>
  );
};

export default Confidentiality;
